import React, { useEffect, useState } from 'react';
import { FormControlLabel, Input, ListItem, NativeSelect } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Button from "components/CustomButtons/Button";
import { RemoveCircleOutline } from "@mui/icons-material";
import { numbercomparatorData } from "variables/lists/alerts";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import {withStyles} from "@mui/styles";
import advancedSearchStyle from "assets/jss/material-dashboard-pro-react/components/advancedSearchStyle";
import ListSubheader from "@mui/material/ListSubheader";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import SettingsIcon from '@mui/icons-material/Settings';
import AdvancedDefDialog from './AdvancedDefDialog';
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import Dialog from "@mui/material/Dialog";

const DialogContent = withStyles((theme) => ({
    root: {
        padding: '16px',
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: '8px',
    },
}))(MuiDialogActions);

function RuleLineCondition(props) {

    const { classes, obj, id, granularity } = props;
    const [itemsCondition, setItemsCondition] = useState([]);
    const [opendef1, setOpendef1] = useState(false);
    const [opendef2, setOpendef2] = useState(false);

    const handleClickOpenDef1 = () => {
        setOpendef1(true);
    };
    const handleEditCloseDef1 = () => {
        setOpendef1(false);
    };
    const handleClickOpenDef2 = () => {
        setOpendef2(true);
    };
    const handleEditCloseDef2 = () => {
        setOpendef2(false);
    };


    const handleOptions = (event, id) => {
        console.log(event);
        obj.item = event.target.value;
        props.handleConditionChange();
    }

    const handleOptions2 = (event, id) => {
        obj.item2 = event.target.value;
        props.handleConditionChange();
    }

    const handleComparator = (event) => {
        obj.comparator = event.target.value;
        props.handleConditionChange();
    }

    const handleOptionValue = (event) => {
        obj.value = event.target.value;
        props.handleConditionChange();
    }

    useEffect(() => {
        // let tmpitemsconditions = <ListSubheader>--Indicateurs--</ListSubheader>;
        // props.indicatordata.map(item => {
        //     tmpitemsconditions += <MenuItem value={"" + item.id} key={item.id}>{item.name}</MenuItem>
        // });
        // setItemsCondition(props.indicatordata.map(item => {
        //     return <option value={""+item.id} key={item.id}>{item.name}</option>;
        // }));
        // console.log(tmpitemsconditions);
        // setItemsCondition(tmpitemsconditions);
    }, [props.indicatordata]);

    return (
        <>{obj ?
            <ListItem>
                <GridContainer>
                    {/* <GridItem xs={6} md={1} lg={1}>
                        <FormControlLabel
                            className={classes.formControlLabel}
                            value="remove"
                            control={
                                <Button
                                    type="button"
                                    round color="transparent" justIcon
                                    size={"sm"}
                                //onClick={() => props.removeCondition(id)}
                                >
                                    <SettingsIcon> </SettingsIcon>
                                </Button>
                            }
                            labelPlacement="start"
                            label={''}
                        />
                    </GridItem> */}
                    <GridItem xs={6} md={4} lg={4} style={{ display: 'flex' }}>
                        {((granularity === '1h' || granularity === '1d' || granularity === '1M') && obj.defitem1) ?
                            <FormControlLabel
                                className={classes.formControlLabel}
                                value="remove"
                                control={
                                    <Button
                                        type="button"
                                        round color="transparent" justIcon
                                        size={"sm"}
                                        onClick={() => handleClickOpenDef1()}
                                    >
                                        <SettingsIcon> </SettingsIcon>
                                    </Button>
                                }
                                labelPlacement="start"
                                label={''}
                                style={{ marginRight: "1px" }}
                            /> : <></>
                        }
                        <FormControl fullWidth>
                            {
                                props.dataType === 'indic' ?
                                    <Select
                                        className={classes.nativeSelect}
                                        inputProps={{ name: "optionsItems", id: "optionsItems" }}
                                        onChange={(event) => {
                                            handleOptions(event, props.id)
                                        }}
                                        value={obj?.item}
                                    >
                                        <ListSubheader>--Indicateurs--</ListSubheader>
                                        {
                                            props.indicatordata && props.indicatordata.map((item) => {
                                                return (
                                                    <MenuItem value={"" + item.id} key={item.id}>{item.name}</MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                    : props.dataType === 'def' ?
                                        <Select
                                            className={classes.nativeSelect}
                                            inputProps={{ name: "optionsItems", id: "optionsItems" }}
                                            onChange={(event) => {
                                                handleOptions(event, props.id)
                                            }}
                                            value={obj?.item}
                                        >

                                            <ListSubheader>--Type de données--</ListSubheader>
                                            {
                                                props.dictionnarydata && props.dictionnarydata.map((item) => {
                                                    return (
                                                        <MenuItem value={"" + item.id} key={item.id}>{item.name}</MenuItem>
                                                    )
                                                })
                                            }
                                        </Select>
                                        : props.dataType === 'point' ?
                                            <Select
                                                className={classes.nativeSelect}
                                                inputProps={{ name: "optionsItems", id: "optionsItems" }}
                                                onChange={(event) => {
                                                    handleOptions(event, props.id)
                                                }}
                                                value={obj?.item}
                                            >
                                                <ListSubheader>--Points de données--</ListSubheader>
                                                {
                                                    props.pointsdata && props.pointsdata.map((item) => {
                                                        return (
                                                            <MenuItem value={"" + item.id} key={item.id}>{item.name}</MenuItem>
                                                        )
                                                    })
                                                }

                                            </Select>
                                            : <></>

                            }
                        </FormControl>
                    </GridItem>
                    <GridItem xs={6} md={1} lg={1}>
                        <FormControl>
                            <FormControl>
                                <NativeSelect inputProps={{ name: "comparator", id: "comparator" }}
                                    onChange={handleComparator}
                                    value={obj?.comparator}
                                    className={classes.nativeSelect}
                                >
                                    {
                                        numbercomparatorData.map(comp => {
                                            return <option value={comp.name} key={comp.name}> {comp.value} </option>
                                        })
                                    }
                                </NativeSelect>
                            </FormControl>
                        </FormControl>
                    </GridItem>
                    <GridItem xs={6} md={4} lg={4} style={{ display: 'flex' }}>
                        {((granularity === '1h' || granularity === '1d' || granularity === '1M') && obj.defitem1) ?
                            <FormControlLabel
                                className={classes.formControlLabel}
                                value="remove"
                                control={
                                    <Button
                                        type="button"
                                        round color="transparent" justIcon
                                        size={"sm"}
                                        onClick={() => handleClickOpenDef2()}
                                    >
                                        <SettingsIcon> </SettingsIcon>
                                    </Button>
                                }
                                labelPlacement="start"
                                label={''}
                                style={{ marginRight: "1px" }}
                            /> : <></>
                        }
                        <FormControl fullWidth>
                            {
                                props.dataType === 'indic' ?
                                    <Select
                                        className={classes.nativeSelect}
                                        inputProps={{ name: "optionsItems", id: "optionsItems" }}
                                        onChange={(event) => {
                                            handleOptions2(event, props.id)
                                        }}
                                        value={obj?.item2}
                                    >
                                        <MenuItem value={"value"} key={"value"}>Valeur</MenuItem>
                                        <ListSubheader>--Indicateurs--</ListSubheader>
                                        {
                                            props.indicatordata && props.indicatordata.map((item) => {
                                                return (
                                                    <MenuItem value={"" + item.id} key={item.id}>{item.name}</MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                    : props.dataType === 'def' ?
                                        <Select
                                            className={classes.nativeSelect}
                                            inputProps={{ name: "optionsItems", id: "optionsItems" }}
                                            onChange={(event) => {
                                                handleOptions2(event, props.id)
                                            }}
                                            value={obj?.item2}
                                        >
                                            <MenuItem value={"value"} key={"value"}>Valeur</MenuItem>
                                            <ListSubheader>--Type de données--</ListSubheader>
                                            {
                                                props.dictionnarydata && props.dictionnarydata.map((item) => {
                                                    return (
                                                        <MenuItem value={"" + item.id} key={item.id}>{item.name}</MenuItem>
                                                    )
                                                })
                                            }
                                        </Select>
                                        : props.dataType === 'point' ?
                                            <Select
                                                className={classes.nativeSelect}
                                                inputProps={{ name: "optionsItems", id: "optionsItems" }}
                                                onChange={(event) => {
                                                    handleOptions2(event, props.id)
                                                }}
                                                value={obj?.item2}
                                            >
                                                <MenuItem value={"value"} key={"value"}>Valeur</MenuItem>
                                                <ListSubheader>--Points de données--</ListSubheader>
                                                {
                                                    props.pointsdata && props.pointsdata.map((item) => {
                                                        return (
                                                            <MenuItem value={"" + item.id} key={item.id}>{item.name}</MenuItem>
                                                        )
                                                    })
                                                }

                                            </Select>
                                            : <></>

                            }
                        </FormControl>
                    </GridItem>
                    <GridItem xs={6} md={3} lg={2}>
                        <FormControl>
                            <Input type={"text"}
                                name={'forumule'}
                                onChange={handleOptionValue}
                                placeholder={"formule"}
                                className={classes.nativeSelect}
                                value={obj?.value}
                            />
                        </FormControl>
                    </GridItem>
                    <GridItem xs={6} md={3} lg={1}>
                        <FormControlLabel
                            className={classes.formControlLabel}
                            value="remove"
                            control={
                                <Button
                                    type="button"
                                    round color="transparent" justIcon
                                    size={"sm"}
                                    onClick={() => props.removeCondition(id)}
                                >
                                    <RemoveCircleOutline> </RemoveCircleOutline>
                                </Button>
                            }
                            labelPlacement="start"
                            label={props.whichCondition}
                        />
                    </GridItem>
                </GridContainer>
            </ListItem>
            : <></>}
            <Dialog
                onClose={handleEditCloseDef1}
                aria-labelledby="edituser-dialog-title"
                fullWidth="true"
                maxWidth="md"
                open={opendef1}
            >
                <CustomDialogTitle id="customized-dialog-title" onClose={handleEditCloseDef1}>
                    Paramètres de la valeur
                </CustomDialogTitle>
                <DialogContent dividers>
                    <AdvancedDefDialog
                        closeModal={handleEditCloseDef1}
                        granularity={granularity}
                        def={obj.defitem1}
                    />
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
            <Dialog
                onClose={handleEditCloseDef2}
                aria-labelledby="edituser-dialog-title"
                fullWidth="true"
                maxWidth="md"
                open={opendef2}
            >
                <CustomDialogTitle id="customized-dialog-title" onClose={handleEditCloseDef2}>
                    Paramètres de la valeur
                </CustomDialogTitle>
                <DialogContent dividers>
                    <AdvancedDefDialog
                        closeModal={handleEditCloseDef2}
                        granularity={granularity}
                        def={obj.defitem2}
                    />
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
        </>

    );

}

export default withStyles(advancedSearchStyle)(RuleLineCondition);

RuleLineCondition.propTypes = {
    id: PropTypes.string,
    removeCondition: PropTypes.func,
    whichCondition: PropTypes.string,
    obj: PropTypes.object,
}

